module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/amazon-cognito-identity-js/~/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 401
// module chunks = 1